var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"qrcodeImg"},[_c('el-image',{attrs:{"src":_vm.url,"preview-src-list":_vm.srcList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }